import { Helmet } from "react-helmet-async";

const SITE_NAME = "SoloConnect";
const BASE_URL = "https://www.soloconnect.in";
const DEFAULT_IMAGE = `${BASE_URL}/preview.png`;

const SEO = ({
  title,
  description,
  keywords,
  canonical,
  image = DEFAULT_IMAGE,
  robots = "index,follow",
  children,
}) => {
  const pageTitle = title
    ? `${title} | ${SITE_NAME}`
    : "SoloConnect - Find Travel Buddies & Travel Together";

  const pageDescription =
    description ||
    "SoloConnect helps solo travelers find verified travel buddies, connect with like-minded explorers, and travel safely together.";

  const pageCanonical = canonical
    ? `${BASE_URL}${canonical}`
    : BASE_URL;

  return (
    <Helmet>
      {/* Basic SEO */}
      <title>{pageTitle}</title>

      <meta name="description" content={pageDescription} />

      <meta name="robots" content={robots} />

      {keywords && (
        <meta name="keywords" content={keywords} />
      )}

      <link rel="canonical" href={pageCanonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />

      <meta property="og:site_name" content={SITE_NAME} />

      <meta property="og:title" content={pageTitle} />

      <meta
        property="og:description"
        content={pageDescription}
      />

      <meta property="og:url" content={pageCanonical} />

      <meta property="og:image" content={image} />

      {/* Twitter */}

      <meta name="twitter:card" content="summary_large_image" />

      <meta name="twitter:title" content={pageTitle} />

      <meta
        name="twitter:description"
        content={pageDescription}
      />

      <meta name="twitter:image" content={image} />

      {children}
    </Helmet>
  );
};

export default SEO;